<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row class="ma-0">
        <v-col class="text-right" cols="12" >
            <v-btn color="kbPurple"
                   dark
                   @click="onPickFile()"
                   v-if="campaign.status === 'draft' || campaign.status === 'inReview'">
                {{ $t('general.importMorePeople') }}
                <v-icon right>
                    insert_drive_file
                </v-icon>
            </v-btn>

            <input type="file" style="display: none" ref="fileInput" accept=".csv,.xlsx,xls" @change="onFilePicked">
        </v-col>
        <v-col cols="12">
            <v-row class="flex-wrap">
                <v-col cols="6" class="py-0">
                    <v-select v-model="advancedSearchCampaignUsers.status"
                              color="kbDarkBlueText"
                              :label="$t('general.status')"
                              :items="itemsStatus"
                              item-text="label"
                              item-value="value">
                    </v-select>
                </v-col>

                <v-col cols="6" class="py-0">
                    <v-text-field v-model="searchCampaignUsers"
                                  color="kbDarkBlueText"
                                  :placeholder="$t('general.search')"
                                  append-icon="search"
                                  clearable>
                    </v-text-field>
                </v-col>
            </v-row>
        </v-col>
        <v-col class="pa-0" cols="12" >
          <sent-users :items="campaignUsers"
                      :totalItems="totalCampaignUsers"
                      :type="campaign.type"
                      :pagination="pagination"
                      :loading="false"
                      @setPagination="setPagination"/>
        </v-col>
    </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
import SentUsers from '@/pages/App/Communications/SentUsers/SentUsers'
export default {
  components: { SentUsers },
  computed: {
    ...mapState({
      advancedSearchCampaignUsers: state => state.campaigns.advancedSearchCampaignUsers,
      campaign: state => state.campaigns.campaign,
      campaignUsers: function (state) {
        const campUsrs = [...state.campaigns.campaignUsers]
        for (let i = 0; i < campUsrs.length; i++) {
          let campUsr = campUsrs[i]
          try {
            if (this.campaign.type === 'massive') {
              if (campUsr.status === 'sent' && campUsr.responseStatus === 'rejected') {
                campUsr = 'not_interested'
              }
              if (campUsr.status === 'sent' && campUsr.responseStatus === 'delivered') {
                campUsr.sentStatus = 'done_all'
              }
              if (campUsr.status === 'pending' && campUsr.responseStatus === 'none') {
                campUsr.sentStatus = 'timer'
              }
              if (campUsr.status === 'sent' && campUsr.responseStatus === 'none') {
                campUsr.sentStatus = 'done'
              }
            } else {
              if (campUsr.status === 'pending' && campUsr.responseStatus === 'none') {
                campUsr.sentStatus = 'pending'
              }
            }
          } catch (e) {
            console.log(e.message)
          }
          try {
            if (campUsr.info && campUsr.info.message) {
              campUsr.message = campUsr.info.message
            } else if (campUsr.info && campUsr.info.mailData && campUsr.info.mailData.info.html) {
              campUsr.message = campUsr.info.mailData.info.html
            }
            campUsr.phoneNumber = campUsr.phone.number
            campUsr.countryCode = campUsr.phone.countryCode
          } catch (e) {
            console.log(e.message)
          }
        }
        return campUsrs
      },
      language: state => state.auth.language,
      paginationCampaignUsers: state => state.users.paginationCampaignUsers,
      selectedApp: state => state.apps.selectedApp,
      totalCampaignUsers: state => state.campaigns.totalCampaignUsers
    }),
    progressCampaign () {
      if (this.campaignProgress.totalUsers === 0) return 0
      return parseInt((this.campaignProgress.totalImported * 100) / this.campaignProgress.totalUsers)
    },
    progressDelivered () {
      if (this.campaign.totalSent === 0) return 0
      return parseInt((this.campaign.totalDelivered * 100) / this.campaign.totalSent)
    },
    progressRejected () {
      if (this.campaign.totalSent === 0) return 0
      return parseInt((this.campaign.totalRejected * 100) / this.campaign.totalSent)
    },
    progressSent () {
      if (this.campaign.totalSent === 0) return 0
      return parseInt((this.campaign.totalSent * 100) / this.campaign.totalUsers)
    },
    searchCampaignUsers: {
      get () {
        return this.$store.state.campaigns.searchCampaignUsers
      },
      set (value) {
        this.$store.commit('SET_SEARCH_CAMPAIGN_USERS', value)
      }
    },
    status () {
      if (this.campaign.status === 'sending') return 'ENVIANDO'
      if (this.campaign.status === 'sent') return 'ENVIADA'
      if (this.campaign.status === 'inReview') return 'EN ESPERA'
      if (this.campaign.status === 'draft') return 'EN BORRADOR'
      return ''
    },
    itemsStatus () {
      let itemStatus = [
        { label: this.statusProps.all.singularLabel, value: this.statusProps.all.filterValue },
        { label: this.statusProps.pending.singularLabel, value: this.statusProps.pending.filterValue },
        { label: this.statusProps.sent.singularLabel, value: this.statusProps.sent.filterValue },
        { label: this.statusProps.delivered.singularLabel, value: this.statusProps.delivered.filterValue },
        { label: this.statusProps.rejected.singularLabel, value: this.statusProps.rejected.filterValue }
      ]
      if (this.campaign.type === 'email') {
        const itemStatusEmail = [
          { label: this.statusProps.deferral.singularLabel, value: this.statusProps.deferral.filterValue },
          { label: this.statusProps.hardBounce.singularLabel, value: this.statusProps.hardBounce.filterValue },
          { label: this.statusProps.softBounce.singularLabel, value: this.statusProps.softBounce.filterValue },
          { label: this.statusProps.open.singularLabel, value: this.statusProps.open.filterValue },
          { label: this.statusProps.click.singularLabel, value: this.statusProps.click.filterValue },
          { label: this.statusProps.spam.singularLabel, value: this.statusProps.spam.filterValue },
          { label: this.statusProps.unsub.singularLabel, value: this.statusProps.unsub.filterValue },
          { label: this.statusProps.blacklist.singularLabel, value: this.statusProps.blacklist.filterValue },
          { label: this.statusProps.whitelist.singularLabel, value: this.statusProps.whitelist.filterValue }
        ]
        itemStatus = itemStatus.concat(itemStatusEmail)
      }
      return itemStatus
    }
  },
  data () {
    return {
      headersCampaign: [
        { text: '', align: 'left', sortable: false },
        { text: this.$t('general.name'), align: 'left', sortable: false },
        { text: 'Email', align: 'left', sortable: false },
        { text: this.$t('general.phone'), align: 'left', sortable: false },
        { text: this.$t('general.message'), align: 'center', sortable: false }
      ],
      headersSmsMassive: [
        { text: '', align: 'left', sortable: false },
        { text: this.$t('general.phone'), align: 'left', sortable: false },
        { text: this.$t('general.message'), align: 'left', sortable: false }
      ],
      pagination: {}
    }
  },
  methods: {
    getCampaignUsers () {
      this.$store.commit('SET_PAGINATION_CAMPAIGN_USERS', this.pagination)
      this.$store.dispatch('getCampaignUsersList', { campaignId: this.$route.params.campaignid })
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      this.uploadingFile = true
      const file = event.target.files[0]
      this.$set(file, 'status', 'pending')
      this.file = file
      event.target.value = ''

      this.$store.dispatch('uploadUsersForTheCampaignDirectly', {
        campaignId: this.campaign._id,
        file: this.file
      }).then(() => {
        this.loading = false
      }).catch(error => {
        notifications.error(error.message)
        this.loading = false
      })
    },
    userStatus (item) {
      if (item.status === 'pending' && item.responseStatus === 'none') return 'pending'
      if (item.status === 'sent' && item.responseStatus === 'none') return 'sent'
      if (item.responseStatus === 'delivered') return 'delivered'
      if (item.responseStatus === 'rejected') return 'rejected'
    },
    setPagination (pagination) {
      this.pagination = pagination
    }
  },
  watch: {
    language () {
      this.headersCampaign[1].text = this.$t('general.name')
      this.headersCampaign[3].text = this.$t('general.phone')
      this.headersCampaign[4].text = this.$t('general.message')
      this.headersSmsMassive[1].text = this.$t('general.phone')
      this.headersSmsMassive[2].text = this.$t('general.message')
    },
    'advancedSearchCampaignUsers.status': function () {
      this.getCampaignUsers()
    },
    pagination: {
      handler () {
        this.getCampaignUsers()
      },
      deep: true
    },
    searchCampaignUsers () {
      this.pagination.page = 1
      this.getCampaignUsers()
    }
  },
  props: ['statusProps']
}
</script>
